import { Header } from '@app/components/header/Header';
import { HeaderWrapper } from '@app/components/header/HeaderWrapper';
import { getCompanyName, getIsLoggedIn } from '@app/ducks';
import cx from 'classnames';
import { useSelector } from 'react-redux';

import { LayoutContent } from './LayoutParts/LayoutContent';
import { LayoutImage } from './LayoutParts/LayoutImage';
import styles from './StartPageLayout.module.scss';

interface Props {
  title: string;
  text?: string;
}

export const StartPageLayout = ({ children, title, text }: React.WithChildren<Props>) => {
  const isUserLoggedIn = useSelector(getIsLoggedIn);
  const companyName = useSelector(getCompanyName);

  return (
    <div className={cx(styles.wrapper, { [styles.withHeader]: isUserLoggedIn })}>
      {isUserLoggedIn && (
        <div className="absolute left-0 right-0 top-0">
          <HeaderWrapper>
            <Header />
          </HeaderWrapper>
        </div>
      )}
      <main className={cx(styles.panel, 'bg-neutral-96')}>
        {!isUserLoggedIn && <h1 className="sr-only">{companyName}</h1>}
        <div className={styles.mobilePanel}>
          <LayoutContent title={title} text={text}>
            {children}
          </LayoutContent>
        </div>
      </main>
      <LayoutImage className={styles.imageWrapper} />
    </div>
  );
};
